import { Resource } from '3map-models';

export type MapResource = Resource & {
  status: 'ENABLED' | 'DISABLED' | 'LOADING' | 'ERROR';
};
